import React, { useEffect } from "react";
import TagCreateWebPage from "./(web)/TagCreateWebPage";
import useMediaView from "features/common/hooks/useMediaView";
import TagCreateMobilePage from "./(mobile)/TagCreateMobilePage";
import useBeforeUnload from "features/common/hooks/useBeforeUnload";
import SaveWarningModal from "pages/user/dashboard/detail/SaveWarningModal";
import { FormProvider, useForm } from "react-hook-form";
import { TagFormData } from "components/foundation/Tag/TagEditForm";

const TagCreatePage = () => {
  const isSmall = useMediaView("small");
  const {
    blocking,
    process,
    isBlock,
    enableUnloadTracking,
    disableUnloadTracking,
  } = useBeforeUnload({
    isInitialTracking: false,
  });
  const methods = useForm<TagFormData>({
    defaultValues: {
      tag: "",
    },
  });

  useEffect(() => {
    methods.formState.isDirty && enableUnloadTracking();
  }, [enableUnloadTracking, methods.formState.isDirty]);

  return (
    <>
      <FormProvider {...methods}>
        <SaveWarningModal
          isOpen={isBlock}
          onConfirm={process}
          onCancel={blocking}
        />
        {isSmall && (
          <TagCreateMobilePage disableUnloadTracking={disableUnloadTracking} />
        )}
        {!isSmall && (
          <TagCreateWebPage disableUnloadTracking={disableUnloadTracking} />
        )}
      </FormProvider>
    </>
  );
};

export default TagCreatePage;
